export const CONTAINER = '.ws-container';
export const COLUMN = 'ws-column';
export const BLOCK_CONTENT = '.ws-block-content';
